// src/pages/admin/AdminRolesPage.js
import React, { useEffect, useState } from 'react'
import { collection, getDocs } from 'firebase/firestore'
import { db } from '../../firebaseConfig'
import { useNavigate } from 'react-router-dom'

// 🔒 Daftar permission valid agar summary tidak error
const SAFE_PERMS = [
  'dashboard',
  'users',
  'therapists',
  'therapist_services',
  'cleaners',
  'cleaner_services',
  'area_coverage',
  'finance',
  'orders',
  'reports',
  'drivers',
  'inbox',
  'settings',
  'admin_management',
]

export default function AdminRolesPage() {
  const [roles, setRoles] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDocs(collection(db, 'admin_roles'))
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        setRoles(list)
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  if (loading) return <div className="p-5 text-white">Loading roles...</div>

  return (
    <div className="p-5 text-white">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold">Admin Roles</h1>

        <button
          className="px-3 py-2 bg-blue-600 rounded"
          onClick={() => {
            const name = window.prompt('Nama role baru (contoh: custom_admin):')
            if (name)
              navigate(`/admin-management/roles/${encodeURIComponent(name)}`)
          }}
        >
          Add Role
        </button>
      </div>

      {/* LIST ROLES */}
      <div className="space-y-3">
        {roles.map((r) => (
          <div
            key={r.id}
            className="p-3 bg-gray-800 rounded border border-gray-700 flex justify-between items-center"
          >
            <div>
              <div className="font-semibold">{r.id}</div>

              <div className="text-sm text-gray-400">
                {SAFE_PERMS.filter((perm) => r[perm]).join(', ') ||
                  'no permission'}
              </div>
            </div>

            <div className="flex gap-2">
              <button
                className="px-3 py-1 bg-yellow-500 rounded"
                onClick={() =>
                  navigate(
                    `/admin-management/roles/${encodeURIComponent(r.id)}`
                  )
                }
              >
                Edit
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
